import { toQueryString } from "../utils";
import { redisGetHandler } from "../utils/redis";

export default (axios, config) => ({
  // Где вызывается: сервер.
  // limit: подсказке в шапке хватает значения по умолчанию, странице
  // результатов нужна вся выдача — иначе фильтры и пагинация врут.
  async searchProducts(q = "", limit = 0) {
    const limitParam = limit ? `&limit=${Number(limit)}` : "";
    const { data } = await axios.get(
      `${config.SERVICE_DATABASE_API_URL}/product/searchIds?q=${encodeURIComponent(q)}${limitParam}`,
      // `http://localhost:3010/database/product/searchIds?q=${encodeURIComponent(q)}`,
      // `http://localhost:3010/database/product/searchIds?variants=${variants}`,
    );
    return Array.isArray(data) ? data : [];
  },
  // Где вызывается: клиент и сервер.
  async getManagerComments(ids) {
    const url = `${config.API_URL}/catalog_v2/getManagerComments`;
    const { data } = await axios.get(`${url}?${toQueryString({ ids })}`);
    return data;
  },
  // Где вызывается: сервер.
  async getClientComments(Redis, reset = false) {
    return redisGetHandler(
      Redis,
      axios,
      config.API_URL,
      `/catalog_v2/getClientComments`,
      reset,
    );
  },
});
